import { ColumnTitle } from "@sinecycle/growcomponents";
import { Flex } from "antd";

function ColumnFooter() {
  return (
    <Flex align="center" gap="var(--space-4)">
      <ColumnTitle hasSymbol />
      <ColumnTitle style={{ color: "var(--gray-7)" }}>
        Custom Fields
      </ColumnTitle>
    </Flex>
  );
}

export { ColumnFooter };
